import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "row gx-0 mb-30 px-xl-40" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "filter-left d-flex align-items-center flex-wrap" }
const _hoisted_5 = {
  type: "button",
  class: "btn style-two me-2 mb-2 mb-md-0",
  "data-bs-toggle": "modal",
  "data-bs-target": "#purchaseFilterModal"
}
const _hoisted_6 = {
  class: "search-area position-relative w-sm-100 flex-grow-1 purchase-search-wrap",
  style: {"max-width":"300px"}
}
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "filter-right d-flex align-items-center justify-content-md-end flex-wrap" }
const _hoisted_10 = { class: "btn btn-outline-info upload-btn me-2 mb-2 mb-md-0 shadow-sm position-relative overflow-hidden" }
const _hoisted_11 = {
  class: "modal fade",
  id: "purchaseFilterModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_12 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_13 = { class: "modal-content border-0 shadow" }
const _hoisted_14 = { class: "modal-header border-bottom-dashed" }
const _hoisted_15 = { class: "modal-title fw-bold" }
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = { class: "modal-body" }
const _hoisted_18 = { class: "row g-3" }
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = { class: "form-label fs-14 text-title" }
const _hoisted_21 = { value: "" }
const _hoisted_22 = { value: "paid" }
const _hoisted_23 = { value: "partial" }
const _hoisted_24 = { value: "pending" }
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { class: "form-label fs-14 text-title" }
const _hoisted_27 = { value: "" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { class: "form-label fs-14 text-title" }
const _hoisted_31 = { value: "" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "modal-footer border-top-dashed justify-content-between" }
const _hoisted_34 = {
  type: "button",
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}

import { computed, onMounted, ref } from "vue";
import Swal from "sweetalert2";
import { useI18n } from "vue-i18n";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import PurchaseList from "../../components/Purchases/PurchaseList/PurchaseList.vue";
import PurchaseDetails from "../../components/Purchases/PurchaseList/PurchaseDetails.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import { usePurchase } from "../../composables/usePurchase";
import { getPurchase, type Purchase } from "../../services/purchase";


export default /*@__PURE__*/_defineComponent({
  __name: 'PurchaseListPage',
  setup(__props) {

const { t } = useI18n();
const selectedPurchase = ref<Purchase | null>(null);
const loadingDetails = ref(false);

const {
  purchases,
  loading,
  searchQuery,
  selectedIds,
  warehouses,
  suppliers,
  filters,
  pagination,
  stateStore,
  fetchDropdownData,
  fetchPurchases,
  handleTableChange,
  resetFilters,
  handleExport,
  handleImport,
  deleteSinglePurchase,
  deleteSelectedPurchases,
  formatDate,
  getDueAmount,
  normalizePaymentStatus,
  normalizePurchaseStatus,
} = usePurchase();

const tablePagination = computed(() => ({
  current: pagination.current,
  pageSize: pagination.pageSize,
  total: pagination.total,
  showSizeChanger: pagination.showSizeChanger,
  pageSizeOptions: pagination.pageSizeOptions,
  showTotal: pagination.showTotal,
}));

const handleViewDetails = async (purchase: Purchase) => {
  if (!purchase.id || loadingDetails.value) return;

  loadingDetails.value = true;

  try {
    const response = await getPurchase(purchase.id);
    selectedPurchase.value = response?.data ?? response;
  } catch (error) {
    console.error("Error loading purchase details:", error);
    Swal.fire({
      icon: "error",
      title: t("purchase_page.failed_to_load_purchase_details"),
      text: t("purchase_page.please_try_again"),
    });
  } finally {
    loadingDetails.value = false;
  }
};

const handleSelectedIdsUpdate = (value: number[]) => {
  selectedIds.value = value;
};

const closeDetails = () => {
  selectedPurchase.value = null;
};

const handlePaymentAdded = async (purchase?: Purchase) => {
  await fetchPurchases();
  if (purchase) {
    selectedPurchase.value = purchase;
  }
};

const handlePurchaseDeleted = async () => {
  await fetchPurchases();
  selectedPurchase.value = null;
};

onMounted(async () => {
  await fetchDropdownData();
  await fetchPurchases();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MainHeader),
    _createVNode(MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BreadcrumbMenu, { pageTitle: "purchase_list" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.$t("purchase_page.filter")) + " ", 1),
              _cache[7] || (_cache[7] = _createElementVNode("i", { class: "ri-filter-line ms-1" }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
                placeholder: _ctx.$t('purchase_page.search_placeholder'),
                class: "w-100 h-55 bg-white border-0 rounded-1 fs-14 text-black ps-3 pe-5 shadow-sm"
              }, null, 8, _hoisted_7), [
                [_vModelText, _unref(searchQuery)]
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("button", {
                type: "button",
                class: "bg-transparent border-0 position-absolute top-50 end-0 translate-middle-y h-auto py-0 px-3 purchase-search-icon",
                tabindex: "-1"
              }, [
                _createElementVNode("i", { class: "ri-search-line" })
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleExport) && _unref(handleExport)(...args))),
              class: "btn btn-outline-success me-2 mb-2 mb-md-0 shadow-sm"
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("i", { class: "ri-file-excel-line me-1" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("purchase_page.excel")), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[10] || (_cache[10] = _createElementVNode("i", { class: "ri-download-line me-1" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("purchase_page.import")) + " ", 1),
              _createElementVNode("input", {
                type: "file",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(handleImport) && _unref(handleImport)(...args))),
                class: "position-absolute top-0 start-0 opacity-0 w-100 h-100 cursor-pointer"
              }, null, 32)
            ]),
            _createVNode(_component_router_link, {
              to: "/create-purchase",
              class: "btn btn-primary shadow-sm"
            }, {
              default: _withCtx(() => [
                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "ri-add-circle-line me-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("create_purchase")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(PurchaseList, {
        purchases: _unref(purchases),
        loading: _unref(loading),
        pagination: tablePagination.value,
        "selected-ids": _unref(selectedIds),
        "format-date": _unref(formatDate),
        "get-due-amount": _unref(getDueAmount),
        "normalize-payment-status": _unref(normalizePaymentStatus),
        "normalize-purchase-status": _unref(normalizePurchaseStatus),
        "state-store": _unref(stateStore),
        "onUpdate:selectedIds": handleSelectedIdsUpdate,
        onTableChange: _unref(handleTableChange),
        onViewDetails: handleViewDetails,
        onDeletePurchase: _unref(deleteSinglePurchase),
        onDeleteSelected: _unref(deleteSelectedPurchases)
      }, null, 8, ["purchases", "loading", "pagination", "selected-ids", "format-date", "get-due-amount", "normalize-payment-status", "normalize-purchase-status", "state-store", "onTableChange", "onDeletePurchase", "onDeleteSelected"]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h5", _hoisted_15, _toDisplayString(_ctx.$t("purchase_page.advanced_filter")), 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close shadow-none",
                "data-bs-dismiss": "modal",
                "aria-label": _ctx.$t('common.close')
              }, null, 8, _hoisted_16)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("purchase_page.payment_status")), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select bg-light border-0 fs-14 shadow-none",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filters).payment_status) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.$t("purchase_page.all_status")), 1),
                    _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.$t("purchase_page.payment_status_paid")), 1),
                    _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.$t("purchase_page.payment_status_partial")), 1),
                    _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.$t("purchase_page.payment_status_pending")), 1)
                  ], 512), [
                    [_vModelSelect, _unref(filters).payment_status]
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("purchase_page.warehouse")), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select bg-light border-0 fs-14 shadow-none",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(filters).warehouse_id) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.$t("purchase_page.all_warehouses")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(warehouses), (w) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: w.id,
                        value: w.id
                      }, _toDisplayString(w.name), 9, _hoisted_28))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(filters).warehouse_id]
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("purchase_page.supplier")), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select bg-light border-0 fs-14 shadow-none",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(filters).supplier_id) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.$t("purchase_page.all_suppliers")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(suppliers), (s) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: s.id,
                        value: s.id
                      }, _toDisplayString(s.name), 9, _hoisted_32))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(filters).supplier_id]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(resetFilters) && _unref(resetFilters)(...args)))
              }, _toDisplayString(_ctx.$t("purchase_page.reset")), 1),
              _createElementVNode("button", _hoisted_34, _toDisplayString(_ctx.$t("purchase_page.apply_filter")), 1)
            ])
          ])
        ])
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(MainFooter)
    ]),
    _createVNode(PurchaseDetails, {
      purchase: selectedPurchase.value,
      onClose: closeDetails,
      onPaymentAdded: handlePaymentAdded,
      onPurchaseDeleted: handlePurchaseDeleted
    }, null, 8, ["purchase"])
  ], 64))
}
}

})